module.exports = __webpack_public_path__ + "img/background005.da160dc8.jpg";